import { render, staticRenderFns } from "./Digital.vue?vue&type=template&id=ca2ccb86&scoped=true"
import script from "./Digital.vue?vue&type=script&lang=js"
export * from "./Digital.vue?vue&type=script&lang=js"
import style0 from "./Digital.vue?vue&type=style&index=0&id=ca2ccb86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2ccb86",
  null
  
)

export default component.exports